var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteMapPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M12.852 8.78c-.228.214-.54.345-.852.345-.31 0-.624-.13-.85-.344a1.238 1.238 0 0 1-.35-.844c0-.308.132-.617.35-.843.443-.439 1.247-.439 1.702 0 .216.226.348.535.348.843 0 .31-.132.618-.348.844M12 4.375c1.986 0 3.6 1.598 3.6 3.563 0 3.802-2.195 7.702-3.532 9.724C10.726 15.397 8.4 11.033 8.4 7.938c0-1.965 1.615-3.563 3.6-3.563m-.052 16.624L12 21c.364 0 .71-.163.938-.445C13.145 20.299 18 14.219 18 7.938 18 4.663 15.308 2 12 2 8.693 2 6 4.664 6 7.938c0 5.051 4.799 12.23 5.002 12.534.212.315.564.511.946.527"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMapPin);
export default __webpack_public_path__ + "static/media/white-map-pin.3d7343fc9c090b5aa836525f965fca1b.svg";
export { ForwardRef as ReactComponent };